<template>
  <!-- 6. 精准洞察 · 各大行业领域深耕 -->
  <div ref="row4" class="pi-justify-center">
    <div
      style="width: 50vw; padding: 85px 160px"
      class="info-industry-content pi-align-end pi-justify-start"
      :style="{
        'background-image': 'url(' + industryList[indTabIndex].img + ')',
      }"
    >
      <div
        class="introduce-container introduce-container-left"
        style="margin-top: 200px"
        :class="isMobile||show ? 'animate__animated animate__fadeInUp' : 'hide'"
      >
        <div class="pi-text-left pi-mg-bottom-20 pi-fz-30 pi-fw-900 pi-white">
          {{ industryList[indTabIndex].title }}
        </div>
        <div>
          <p
            class="pi-fz-16 pi-white"
            style="max-width: 620px; text-align: left"
          >
            {{ industryList[indTabIndex].desc }}
          </p>
        </div>
      </div>
    </div>
    <div style="width: 50vw; background: #f5f5f5; padding: 90px 100px">
      <div class="pi-mg-bottom-60"  :class="isMobile||show ? 'animate__animated animate__fadeInDown' : 'hide'">
        <div
          class="title pi-fz-30 pi-fw-900 pi-text-left pi-mg-bottom-29"
          style="color: #222"
        >
          洞察趋势·深耕行业
        </div>
        <div class="content">
          <p
            style="text-align: left; color: #222"
            class="pi-fz-15 pi-lh-36 pi-fw-400"
          >
            APJ立足于粤港澳大湾区，深刻洞察趋势，专注深耕行业，致力于为客户实现数字化转型提供解决方案，数字化服务涵盖生产制造、医疗健康、交通轨道、石油化工、终端零售、公共事业、教育行业等众多行业。
          </p>
        </div>
      </div>

      <div class="pi-justify-between pi-mg-bottom-20"  :class="isMobile||show ? 'animate__animated animate__fadeInUp' : 'hide'" style="max-width:700px">
        <template v-for="(item, index) in industryList">
          <div
            v-if="index <= 3"
            class="item pi-flex-column-center pi-white"
            :key="'industryList' + index"
            :class="{ 'item-c': indTabIndex == index }"
            @click="indTabIndex = index"
          >
            <i class="pi-fz-32 iconfont ind-tab-icon" style="font-size:32px" :class="item.icon"></i>
            <span class="pi-fz-16 pi-fw-400">{{ item.name }}</span>
          </div>
        </template>
      </div>
       <div class="pi-justify-between" :class="isMobile||show ? 'animate__animated animate__fadeInUp' : 'hide'" style="max-width:700px">
        <template v-for="(item, index) in industryList">
          <div
            v-if="index > 3"
            class="item pi-flex-column-center pi-white"
            :key="'industryList' + index"
            :class="{ 'item-c': indTabIndex == index }"
            @click="indTabIndex = index"
          >
            <i class="pi-fz-32 iconfont ind-tab-icon" style="font-size:32px" :class="item.icon"></i>
            <span class="pi-fz-16 pi-fw-400">{{ item.name }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import data from "../../data";
import { isMobile } from "@/utils";
export default {
  data() {
    return {
      indTabIndex: 0,
      isMobile: isMobile(),
      img_show: false,
      industryList: data.industryList,
    };
  },
  created() {
    this.load()
  },
  methods: {
    load(){
      setInterval(()=>{
        if(this.indTabIndex>this.industryList.length) return this. indTabIndex=0
        this.indTabIndex++
      },3000)
    },
    loadInit() {
      return this.$refs.row4;
    },
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.info-industry-content {
  transition: all .5s;
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 100%;
}
.item {
  transition: all 0.5s;
  margin-left: 10px;
  width: 114px;
  height: 114px;
  cursor: pointer;
  i {
    color: #e60012;
  }
  span {
    font-size: 16px;
  }
  &-c {
    background: #e60012;
    i,
    span {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/row_4/index.vue